<template>
  <div class="register-content" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
    <div class="top-content">
      <router-link to="/" class="head-name">维才考考试平台</router-link>
      <div class="head-title">考生注册</div>
    </div>
    <el-form :model="form" ref="form" :rules="rules" class="register-from">
      <el-form-item prop="realName">
        <el-input
          v-model.trim="form.realName"
          placeholder="请输入真实姓名"
          autofocus
          type="text"
          @keyup.enter.native="handleRegister('form')"
        />
      </el-form-item>
      <el-form-item prop="idCardNo">
        <el-input
          v-model.trim="form.idCardNo"
          placeholder="请输入身份证号"
          type="text"
          @keyup.enter.native="handleRegister('form')"
        />
      </el-form-item>
      <el-form-item prop="phone">
        <el-input
          v-model.trim="form.phone"
          placeholder="请输入11位手机号"
          type="text"
          @keyup.enter.native="handleRegister('form')"
        />
      </el-form-item>
            <el-form-item prop="password">
        <el-input
          v-model.trim="form.password"
          :maxlength="20"
          placeholder="请输入密码"
          type="password"
          @keyup.enter.native="handleRegister('form')"
        />
      </el-form-item>
      <el-form-item prop="isPassword">
        <el-input
          v-model.trim="form.isPassword"
          :maxlength="20"
          placeholder="请输入确认密码"
          type="password"
          @keyup.enter.native="handleRegister('form')"
        />
      </el-form-item>
      <div class="operate">
        <el-button type="primary" class="width-btn" @click="handleRegister('form')">注册</el-button>
      </div>
      <div class="flex-operate">
        <el-link type="primary" href="#/login">立即登录</el-link>
      </div>
    </el-form>
  </div>
</template>

<script>
import { registerByPassword } from '@/api/login'
import { validateIdCardNo, validatePhone, validatePwd } from '@/utils/validate'

export default {
  name: 'Register',
  data() {
    return {
      loading: false,
      form: {
        openId: '',
        realName: '',
        idCardNo: '',
        phone: '',
        password: '',
        isPassword: ''
      },
      rules: {
        realName: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' }
        ],
        idCardNo: [
          { required: true, validator: validateIdCardNo, trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePwd, trigger: 'blur' }
        ],
        isPassword: [
          { required: true, validator: validatePwd, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.form.openId = this.$route.query.openId
  },
  methods: {
    handleRegister(formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.form.password === that.form.isPassword) {
            that.loading = true
            registerByPassword(this.form)
              .then(res => {
                that.loading = false
                if (res.code === 200) {
                  that.$store.dispatch('user/updateToken', res.data.tokenHead + res.data.token)
                  that.$message({
                    message: '注册成功',
                    type: 'success'
                  })
                  setTimeout(() => {
                    that.$router.push('/login')
                  }, 2000)
                }
              })
              .catch(() => {
                that.loading = false
              })
          } else {
            that.$message.error('两次密码不一致');
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.register-content {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  .top-content {
    margin-top: 10%;
    margin-bottom: 40px;
    .head-name {
      font-size: 20px;
      font-weight: bold;
      color: #343a40;
      text-decoration-line: none;
    }
    .head-title {
      font-size: 30px;
      font-weight: 700;
      margin-top: 50px;
      text-align: center;
    }
  }
  .register-from {
    width: 70%;
    max-width: 500px;
    .operate {
      width: 100%;
      .width-btn {
        width: 100%;
      }
    }
    .flex-operate {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
    }
  }
}
</style>
